/**
 * Define an actor with requests and events.
 * @__NO_SIDE_EFFECTS__
 */
export function defineActor(definition) {
    return definition;
}
//# sourceMappingURL=Actor.js.map